class QuickAddCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._selectors = {
      quickaddContainer: '[js-quick-add-container]',
      quickAdd: "[js-product-card-quick-add]",
      options: "[js-product-card-options]",
      quickAddSwatch: "[js-product-card-quick-add-swatch]",
      hiddenSelect: "[js-product-card-select]",
      quickAddATC: "product-form input[name='id']"
    };

    this._setupVariantListeners();
  }

  _setupVariantListeners() {
    this.querySelectorAll(this._selectors.quickAddSwatch).forEach((quickAddSwatch) => {
      quickAddSwatch.addEventListener('click', this._updateVariantId);
    });
  }

  _updateVariantId = (evt) => {
    evt.preventDefault();
    let swatch = evt.target;
    let value = swatch.dataset.value;
    const atcButton = this.querySelector(this._selectors.quickAddATC);
    const hiddenSelect = this.querySelector(this._selectors.hiddenSelect);
    const activeColor = swatch.dataset.color.trim();
    let selectedVariant = ''

    this.querySelectorAll(this._selectors.quickAddSwatch).forEach((quickAddSwatch) => {
      quickAddSwatch.dataset.selected="false";
    });
    swatch.dataset.selected = "true";

    if (activeColor !== null || activeColor !== undefined) {
      selectedVariant = hiddenSelect.querySelector(`option[data-title="${activeColor} / ${value}"]`);
    } else {
      selectedVariant = hiddenSelect.querySelector(`option[data-title="${value}"]`);
    }
    
    let selectedVariantId = parseInt(selectedVariant.value);    
    
    atcButton.value = selectedVariantId;
  }
}
customElements.define('quick-add-card', QuickAddCard);

class QuickAddCardOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    let cardID = button.dataset.cardId;
    if (!button) return;

    let isRotated = false;
    const icon = button.querySelector('.icon');

    button.addEventListener('click', () => {
      const targetElement = document.querySelector(button.getAttribute('data-quick-add-card'));
      const targetCard = document.querySelector(`.card__heading a[data-card-id=${cardID}`);

      if (targetElement) {
        if (targetElement.classList.contains('hidden')) {
          targetElement.classList.remove('hidden'); // Element is hidden, so show it
        } else {
          targetElement.classList.add('hidden'); // Element is visible, so hide it
        }

        if (isRotated) {
          icon.style.transform = 'rotate(0deg)';
          isRotated = false;
        } else {
          icon.style.transform = 'rotate(45deg)';
          isRotated = true;
        }
      }

      if(targetCard) {
        if (targetCard.classList.contains('psuedo-after')) {
          targetCard.classList.remove('psuedo-after');
        } else {
          targetCard.classList.add('psuedo-after');
        }
      }
    });
  }
}
customElements.define('quick-add-card-opener', QuickAddCardOpener);
